<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <el-button v-if="(type === 1 || type === 2)" @click="addOrEdit" :loading="btnLoading">抽取评审人</el-button>
      <el-button  @click="close">关闭</el-button>
    </div> -->
    <div>
      <el-form :model="project" label-position="left" label-width="120px">
      <div class="name">项目名称：<span>{{project.projectname}}</span></div>
      </el-form>
      <el-form :model="project" label-position="left" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="外部评审人人数"  prop="prswexperts" verify :gte="0">
              <el-input v-model="project.prswexperts" :maxlength="4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 80px;">
            <el-form-item label="内部评审人人数"  prop="prsnexperts" verify :gte="0">
              <el-input v-model="project.prsnexperts" :maxlength="4"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 80px;">
              <el-button v-if="(type === 1 || type === 2)" @click="addOrEdit" :loading="btnLoading">抽取评审人</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="400" flexname=""
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
    </vggrid>

  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: "pexpertForm",
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'pexpertlogincode',fieldtype: 'I', title: '登录账号',calculExpr:'', width: 80 },
          { field: 'pexpertloginpwd', fieldtype: 'C', title: '登录密码',calculExpr:''},
          { field: 'pexpertisp', fieldtype: 'F', title: '采购人代表',calculExpr:''},
          { field: 'pexpertpgsstatusname', fieldtype: 'C', title: '评分状态',calculExpr:''},
          { field: 'pexpertpgsconfirmtime', fieldtype: 'T', title: '评分确认时间',calculExpr:'',formatter: ['toDateString', '']},
          { field: 'pexpertsignstatusname', fieldtype: 'C', title: '会签状态',calculExpr:''},
          { field: 'pexpertsignconfirmtime', fieldtype: 'T', title: '会签时间',calculExpr:'',formatter: ['toDateString', '']},
        ]
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getPageList()
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid},
    computed: {
    },
    methods: {
      async init() {
        this.project = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.list = []
        this.project.prswexperts = Number(this.project.prswexperts)
        this.project.prsnexperts = Number(this.project.prsnexperts)
      },
      async getPageList () {
          this.list = await request({
            url: '/xmgl/project/getPexpertList',
            method: "get",
            params: {projectid: this.project.projectid}
          })
      },
      async addOrEdit () {
        if (this.project.projectdoneflg === '1') {
          this.$message.error('价格定标法，不需要抽取评审人评分')
          return
        }

        // 插入评审人数
           let {issuccess} = await request({
              url: '/xmgl/project/saveExperts',
              method: "post",
              data: this.project
            })
          if (issuccess) {
            let data = await request({
              url: '/xmgl/project/pexpertExtract',
              method: "post",
              data: this.project
            })
             if (data.issuccess===1) {
              await this.getPageList()
              this.$message.success('评审人抽取成功')
            } else {
              this.$message.error('评审人抽取失败，失败原因：'+data.msg)
            }
          }
      },
      close () {

        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
    }
  }
</script>

<style scoped>

</style>
